import Breadcrumb from "components/common/Breadcrumb/Breadcrumb";
import DateRangePickerNew from "components/common/DateRangePicker/DateRangePickerNew";
import Header from "components/common/Header/Header";
import SelectOption from "components/common/Select/Select";
import SideBarNew from "components/common/SideBar/SideBarNew";
import {
  REPORTING_BREADCRUMB,
  REPORTING_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import { LoginContext } from "helpers/LoginContext";
import React, { useContext } from "react";
import { connect } from "react-redux";
import {
  ReportFilterActions,
  ReportFilterField,
  ReportFilterGrid,
  ReportFiltersShell,
  ReportPageContent,
  ReportTableSection,
} from "../reportFilterUi";
import Table from "../Table";
import { getParticipantLabel, getLineItemLabel } from "Constants/constant";
import { getSpSetting } from "store/selector/sp.selector";

const InvoicingReports = (props) => {
  const { settings } = props;
  const participantNameLabel = getParticipantLabel(settings?.care_sector, false) + " Name";
  const lineItemLabel = getLineItemLabel(settings?.care_sector);
  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const COLUMNS = [
    {
      header: participantNameLabel,
    },
    { header: "Worker Name" },
    {
      header: "Date",
    },
    {
      header: "Sign In Time",
    },
    {
      header: "Sign Out Time",
    },
    {
      header: "KMs",
    },
    {
      header: `${lineItemLabel} Name`,
    },
    {
      header: `${lineItemLabel} Code`,
    },
    {
      header: "Hours",
    },
  ];

  const handleSearch = () => {
    // searchFilterDataRequest(false);
  };

  const handleClearFilters = () => {
    // setSelectedClient(null);
    // setserviceContract(null);
    // setFromDate(null);
    // setToDate(null);
    // searchFilterDataRequest(true);
  };

  return (
    <div className='min-h-full'>
      <SideBarNew />
      <div
        className={`${
          sideBarPadding ? "lg:pl-[4rem] duration-300" : "lg:pl-64 duration-300"
        }  flex flex-col `}
      >
        <main className='flex-1 bg-gray-50 min-h-screen'>
          <Header
            title='Invoicing Reports'
            breadcrumb={
              <Breadcrumb
                pages={REPORTING_BREADCRUMB(
                  REPORTING_BREADCRUMB_PAGES.INVOICING_REPORTS
                )}
              />
            }
          />
          <ReportPageContent>
            <ReportFiltersShell>
              <ReportFilterGrid columns={4}>
                <ReportFilterField label='Participant'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='pt_id'
                    isSearch={true}
                    // data={clientsList ? clientsList : []}
                    // selectedOption={selectedClient}
                    // handleChange={(e) => {
                    //   setSelectedClient(e);
                    // }}
                    // placeHolder="Participant Name"
                  />
                </ReportFilterField>
                <ReportFilterField label='Worker'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='contact_type_id'
                    isSearch={true}
                    // data={ContactList ? ContactList : []}
                    // handleChange={(e) => {
                    //   setserviceContract(e);
                    // }}
                    // selectedOption={serviceContract}
                    // placeHolder="Services"
                  />
                </ReportFilterField>
                <ReportFilterField label='Select Created Date Range'>
                  <DateRangePickerNew
                    isClearable={false}
                    // handleCancel={handleCancelButton}
                    // handleChange={(obj) => {
                    //   if (obj && obj.fromDate && obj.toDate) {
                    //     setFromDate(obj.fromDate);
                    //     setToDate(obj.toDate);
                    //   }
                    // }}
                    // fromDate={fromDate}
                    // toDate={toDate}
                  />
                </ReportFilterField>
              </ReportFilterGrid>
              <ReportFilterActions
                onSearch={handleSearch}
                onClear={handleClearFilters}
                onExport={() => {
                  // handleFileDownLoad(e);
                }}
                isUserGracePeriodOver={isUserGracePeriodOver}
              />
            </ReportFiltersShell>
            <ReportTableSection>
              <Table COLUMNS={COLUMNS} />
            </ReportTableSection>
          </ReportPageContent>
        </main>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  settings: getSpSetting(state),
});

export default connect(mapStateToProps)(InvoicingReports);
